/**
 * Created by Denís Requejo on 22/01/20.
 */
import { Injectable, }     from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import {EcosensorLog} from './EcosensorLog';

@Injectable()
export class EcosensorLogService {

  private basePath = 'api/v1/ecomanager/';
  constructor(
    private http: HttpClient
  ) {}

  get(iPlaceIds: string, start: number, end: number): Promise<any> {
    let url = this.basePath + 'sensor';
    let params = new HttpParams();
    params = params.append('iPlaceIds', iPlaceIds)
      .append('startDate', start.toString())
      .append('endDate', end.toString());
    return this.http.get(url, { params: params })
      .toPromise()
      .then( res => res as EcosensorLog[])
      .catch( error => this.errorHandler(error) );
  }

  private errorHandler(error: any): Promise<any> {
    console.log('An error occurred', error);
    return Promise.reject(error.message || error);
  }
}
